module.exports = __webpack_public_path__ + "static/media/kv.3a904e3d.jpg";